(function($) {

	if (!$)
	{
		console.error('Contact Support popup disabled: No jQuery');
		return;
	}

	if (!window.BASEURL)
	{
		console.error('Contact Support popup disabled: No BASEURL defined');
		return;
	}

	var ajaxurl = BASEURL + '/wp-admin/admin-ajax.php';

	$(document).on('click', '#wp-admin-bar-contact-support a', function(e) {
		e.preventDefault();

		if ($('#da-contact-support-container').length)
			return;

		function err() {
			alert('Unable to initialize the Digital Attic Support form');
		}

		$.ajax({
			url: ajaxurl,
			type: 'post',
			dataType: 'json',
			data: {
				action: 'contact_support_form',
				method: 'autofill-info'
			},
			success: function(resp) {
				if (!resp)
				{
					err();
					return;
				}

				showForm(resp.name, resp.email);
			},
			error: err
		});
	});

	function buildEl(obj)
	{
		var el = false;

		if (obj.type == 'text')
			el = $('<input type="text"/>');
		else if (obj.type == 'email')
			el = $('<input type="email"/>');
		else if (obj.type == 'textarea')
			el = $('<textarea/>');

		if (el.length === 1)
		{
			if (obj.name)
				el.attr('name', obj.name);
			if (obj.placeholder)
				el.attr('placeholder', obj.placeholder);
			if (obj.required)
				el.prop('required', true);
			if (obj.atts)
				el.attr(obj.atts);
		}

		return el;
	}

	function showForm(name, email) {
		var fields = [
			{
				name: 'name',
				type: 'text',
				label: 'Name',
				placeholder: name
			},
			{
				name: 'email',
				type: 'email',
				label: 'Email',
				placeholder: email
			},
			{
				name: 'link',
				type: 'text',
				label: 'URL',
				placeholder: location.href
			},
			{
				name: 'message',
				type: 'textarea',
				label: 'Message',
				placeholder: 'When I clicked on this thing it broke...',
				atts: {
					cols: 40,
					rows: 5
				},
				required: true
			}
		];

		var tbody = $('<tbody/>');
		for (var i = 0; i < fields.length; i++)
		{
			var tr = $('<tr/>');
			tr.append($('<th/>').text(fields[i].label));
			tr.append($('<td/>').append(buildEl(fields[i])));
			tbody.append(tr);
		}

		var container = tbody
							.wrap('<table/>')
							.parent()
							.wrap('<div class="support-content"/>')
							.parent()
							.wrap('<form class="support-form"/>')
							.parent()
							.prepend($('<div class="support-header"/>').append('<h3>Contact Digital Attic Support</h3>'))
							.append($('<div class="support-footer"/>').append('<input type="button" value="Cancel"/>').append('<input type="submit" value="Submit"/>'))
							.wrap('<div id="support-container"/>')
							.parent();

		$('body')
			.addClass('support-form-visible')
			.append('<div id="support-backdrop"/>')
			.append(container);

		setTimeout(function() {
			$('body').addClass('show-support-form');
		}, 20);
	}

	function dismissForm()
	{
		$('body').removeClass('show-support-form');

		setTimeout(function() {
			$('#support-backdrop, #support-container').remove();
		}, 300);
	}

	function serializeForm(form)
	{
		var arr = form.serializeArray(),
			ret = {};

		for (var i = 0; i < arr.length; i++)
			ret[arr[i].name] = arr[i].value;

		return ret;
	}

	$(document).on('click', '.support-form', function(e) {
		e.stopPropagation();
	});

	$(document).on('click', '#support-container', dismissForm);

	$(document).on('click', '.support-footer [type="button"]', dismissForm);

	$(document).on('submit', '.support-form', function(e) {
		e.preventDefault();

		// Fill empty fields
		$(this).find('input, textarea').each(function() {
			var that = $(this),
				val = $(this).val();

			if (!val)
				that.val(that.attr('placeholder'));
		});

		function err() {
			alert('Unable to submit the form at this time.');
		}

		$.ajax({
			url: ajaxurl,
			type: 'post',
			dataType: 'json',
			data: {
				action: 'contact_support_form',
				method: 'submit',
				fields: serializeForm($(this))
			},
			success: function(resp) {
				if (resp === true)
				{
					alert('Your message has been sent to Digital Attic successfully.');
					dismissForm();
				}
				else
				{
					// error
					resp = (resp && ('Message error:\n' + resp)) || 'Unable to send your message at this time';
					alert(resp);
				}
			}
		});
	});

})(window.jQuery);